// @ts-nocheck
import React from 'react';

const Spinner = ({ size = 18, className = '', label }) => (
  <span className={['inline-flex items-center gap-2 text-mov-ink-soft', className].join(' ')}>
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        border: '2px solid currentColor',
        borderRightColor: 'transparent',
        borderRadius: '50%',
        display: 'inline-block',
        animation: 'mov-spin .7s linear infinite',
      }}
    />
    {label && <span className="text-[13px]">{label}</span>}
  </span>
);

export const FullSpinner = ({ label = 'Loading…' }) => (
  <div className="grid place-items-center w-full" style={{ minHeight: 280 }}>
    <Spinner label={label} />
  </div>
);

export default Spinner;
